import { browser } from '$app/env';

export function writeToLocalStorage<T>(key: string, value: T): void {
	if (!browser) {
		return null;
	}

	localStorage.setItem(key, JSON.stringify(value));
}

export function getFromLocalStorage(key: string, fallback: any = null): any {
	if (!browser) {
		return fallback;
	}

	const item = localStorage.getItem(key);
	return item ? JSON.parse(item) : fallback;
}
